import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { SimplifiedConnectedBreakpointService } from './simplified-connected-breakpoint.service';
import { BreakpointService } from './breakpoint.service';

export enum LayoutSize {
  Xl = 'xl',
  Md = 'md',
  MaxMd = 'maxMd',
}

@Injectable({
  providedIn: 'root',
})
export class ManualBreakpointService implements SimplifiedConnectedBreakpointService {
  iframeConnected = false;
  change$: Observable<boolean>;
  xl$: Observable<boolean>;
  md$: Observable<boolean>;
  private _activeLayoutSize: BehaviorSubject<LayoutSize>;

  constructor(private _breakpointService: BreakpointService) {
    this._activeLayoutSize = new BehaviorSubject<LayoutSize>(
      this._breakpointService.xl ? LayoutSize.Xl : this._breakpointService.md ? LayoutSize.Md : LayoutSize.MaxMd,
    );

    _breakpointService.md$
      .pipe(filter(() => !this.iframeConnected))
      .subscribe((value) => (value ? (this.layoutSize = LayoutSize.Md) : (this.layoutSize = LayoutSize.MaxMd)));
    _breakpointService.xl$
      .pipe(filter(() => !this.iframeConnected))
      .subscribe((value) => (value ? (this.layoutSize = LayoutSize.Xl) : (this.layoutSize = LayoutSize.Md)));

    this.change$ = this._activeLayoutSize.asObservable().pipe(
      distinctUntilChanged(),
      map(() => true),
    );
    this.xl$ = this._activeLayoutSize.pipe(map((x) => x === LayoutSize.Xl));
    this.md$ = this._activeLayoutSize.pipe(map((x) => x === LayoutSize.Md || x === LayoutSize.Xl));
  }

  set layoutSize(value: LayoutSize) {
    if (value) this._activeLayoutSize.next(value);
  }

  get md(): boolean {
    return this._activeLayoutSize.value == LayoutSize.Md || this._activeLayoutSize.value == LayoutSize.Xl;
  }

  get xl(): boolean {
    return this._activeLayoutSize.value == LayoutSize.Xl;
  }
}
